export default "__VITE_ASSET__Cqh6vA$l__"